<template>
    <div class="container-fluid">
        <div class="">
            <div class="caption">
                <input type="text"
                    class="form-control input-caption b-normal shadow-none"
                    ref="caption"
                    v-model="note.caption"
                    @input="changed($event)"
                    maxlength="16"
                    placeholder="ノートの見出し（16文字まで）">
            </div>
            <div class="d-flex justify-content-end" style="margin-bottom: -1rem;">
                <div class="toggle-outline dropdown">
                    <a class="nav-link pointer"
                        @click.prevent="showOutline()" data-toggle="dropdown">
                        <span class="d-inline-block my-1">
                            <i class="fas fa-chevron-circle-down"></i>
                        </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a href="#" class="dropdown-item" :style="{paddingLeft: (v.level) + 'rem'}"
                            :class="{'font-weight-bold': v.level == 1}"
                            v-for="(v, i) in outline" :key="i"
                            @click.prevent="scrollTo(v)">
                            {{$filters.truncate(v.caption, 20)}}
                        </a>
                    </div>
                </div>
            </div>
            <editor :content="$filters.jsonParse(note.memo)"
                ref="editor"
                @change="changed($event)"
                class="fullpage"></editor>
            <div class="row justify-content-center">
                <div class="col-4 text-center small">
                    <editor-storage :content="note.memo"></editor-storage>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <button class="btn btn-outline-danger btn-sm" type="button" @click="remove()">
                    <i class="fas fa-times"></i>
                    <span class="d-none d-md-inline-block">ノートを削除</span>
                </button>
                <div class="small">
                    ノートは自動保存されます。
                </div>
                <button class="btn btn-outline-primary btn-sm" type="button" @click="save()" :disabled="!isEdit">
                    <i class="fas fa-spinner fa-spin" v-if="isSaving"></i>
                    <i class="fas fa-save" v-else></i>
                    <span class="d-none d-md-inline-block">ノートを保存</span>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
$fullpage-height: calc(100vh - 340px);
.caption {
    margin: .5rem 3rem;
    .input-caption {
        font-size: 1.8rem;
        border-bottom: 1px solid #aaa;
    }
}
.fullpage {
    height: $fullpage-height;
}
#block-editor {
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
}
.dropdown-menu {
    max-height: $fullpage-height;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
}

@media (max-width: 820px) {
    .fullpage {
        height: unset;
    }
    .caption {
        margin: .5rem;
    }
}
</style>

<script>
export default {
    props: {
        note_id: {
            default: null
        }
    },
    data() {
        return {
            note: {},
            marked: null,
            isMarkdown: false,
            outline: [],
            dontSave: false,
            isSaving: false,
            isEdit: false,
            timerID: null,
        }
    },
    methods: {
        load() {
            if (this.$route.params.id) {
                axios.get("/mypage/book/note", {params: {id: this.$route.params.id}}).then(res => {
                    this.note = res.data;
                    this.$refs.editor.refresh();
                }).catch(err => { alert.err(err.response) });
            } else {
                this.note = {
                    memo: null
                };
                this.$refs.editor.refresh();
            }
            this.dontSave = false;
        },
        focus() {
            if (!this.note.caption) {
                this.$refs.caption.focus();
            }
        },
        async save() {
            if (this.dontSave) return;
            if (this.$refs.editor) {
                const save_data = await this.$refs.editor.save();
                if (save_data.blocks.length == 0) {
                    return;
                }
                this.note.memo = JSON.stringify(save_data);
            }
            if (!this.note.caption) {
                this.note.caption = "(無題)";
            }
            this.isSaving = true;
            axios.post("/mypage/book/note/save", this.note).then(res => {
                if (!this.note.id) {
                    this.note.id = res.data.id;
                }
                this.isEdit = false;
                this.isSaving = false;
            }).catch(err => {
                alert.err(err.response);
                this.isSaving = false;
            });
        },
        changed(ev) {
            this.isEdit = true;
            if (this.timerID) {
                clearTimeout(this.timerID);
            }
            this.timerID = setTimeout(() => { this.save(); }, 30000);
        },
        remove() {
            Swal.fire({
                title: "ノート削除",
                html: "ノート「" +this.note.caption+ "」を削除します。<br>削除したノートはもとに戻せません。<br>よろしいですか？",
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "ノートを削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/book/note/remove", {id: this.note.id}).then(res => {
                        this.dontSave = true;
                        this.$router.push("/mypage/notes");
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        async showOutline() {
            const note = await this.$refs.editor.save();
            this.outline = [];
            this.outline.push({
                caption: "先頭",
                id: "start",
                level: 1,
            });
            for (const index in note.blocks) {
                const block = note.blocks[index];
                if (block.type === "header") {
                    this.outline.push({
                        id: block.id,
                        caption: block.data.text,
                        level: block.data.level,
                        index: index,
                    });
                }
            }
            this.outline.push({
                caption: "末尾",
                id: "end",
                level: 1,
            });
            return;
        },
        scrollTo(v) {
            let scrollTop = 0;
            if (!v.index) {
                if (v.caption === "末尾") {
                    scrollTop = $("#block-editor")[0].scrollHeight;
                }
            } else {
                const x = parseInt(v.index) + 1;
                scrollTop = $("#block-editor .ce-block:nth-child(" + x + ")")[0].offsetTop;
            }
            $("#block-editor").animate({scrollTop: scrollTop});
        },
        confirm() {
            return Swal.fire({
                title: "保存されていません",
                html: `<div class="text-left">
                    編集中のノートが保存されていません。
                    このままページを離れますか？
                    </div>`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                confirmButtonText: "離れる",
                cancelButtonText: "キャンセル",
                reverseButtons: true,
            });
        },
    },
    computed: {
        markdownText() {
            if (! this.marked || ! this.note.memo) {
                return this.note.memo;
            }
            return this.marked.parse(this.note.memo);
        },
    },
    mounted() {
        this.marked = require("marked");
        this.marked.setOptions({
            breaks: true
        });
        this.isEdit = false;
        this.load();
    },
    async beforeRouteLeave(to, from) {
        if (this.isEdit) {
            const confirm = await this.confirm();
            if (confirm.isConfirmed) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>